import nonBreakingText from "./non-breaking-text";

const formatVehicleTitle = ({ year = "", make = "", model = "", trim }) => {
  return `${year}${make ? nonBreakingText(" ") : ""}${nonBreakingText(
    make.toUpperCase()
  )}${model ? " ": ""}${nonBreakingText(model.toUpperCase())}`.trim();
};

export default formatVehicleTitle;
